import { render, staticRenderFns } from "./Home.data-manager-bundle-wl-details.vue?vue&type=template&id=f503c272&scoped=true&"
import script from "./Home.data-manager-bundle-wl-details.vue?vue&type=script&lang=js&"
export * from "./Home.data-manager-bundle-wl-details.vue?vue&type=script&lang=js&"
import style0 from "./Home.data-manager-bundle-wl-details.vue?vue&type=style&index=0&id=f503c272&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f503c272",
  null
  
)

export default component.exports